import { IconLibraryTypes } from "@liberty-financial/ng-components/lib/components/icon/library.enum";

export class SelectionItem {
  name: string;
  hint: string | null;
  action: () => void;
  icon: IconLibraryTypes;
  disabled: boolean;
  disabledTooltip: string | null;

  constructor(
    name: string,
    action: () => void,
    icon: IconLibraryTypes,
    disabled: boolean = false,
    hint: string | null = null,
    disabledTooltip: string | null = null
  ) {
    this.name = name;
    this.hint = hint;
    this.action = action;
    this.icon = icon;
    this.disabled = disabled;
    this.disabledTooltip = disabledTooltip;
  }

  get onClick(): () => void {
    return this.action
  }
}
